import { memo } from 'react';

const CancelWork = ({ className }) => {
    return (
        <span className={className}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#007CC3" />
                <path d="M5 5L19 19" stroke="#0080C6" strokeWidth="2" strokeLinecap="round" />
                <path d="M19 5L5 19" stroke="#0080C6" strokeWidth="2" strokeLinecap="round" />
            </svg>
        </span>
    );
};
export default memo(CancelWork);